<template>
  <v-container fluid>
    <v-card flat>
      <v-toolbar>
        <v-icon>post_add</v-icon>
        <v-toolbar-title class="font-weight-light">
          <v-row>
            <v-col>
              <div>Alta de Reclamo</div>
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="hide(false)"><v-icon>close</v-icon></v-btn>
      </v-toolbar>

      <v-card-text>
        <v-container fluid>
          <v-row v-if="!selectedPersona" dense>
            <v-col>
              <span>Seleccione a una Persona</span>
            </v-col>
          </v-row>

          <v-row align="center" v-if="!selectedPersona">
            <v-col cols="12">
              <app-busqueda-personas
                :personaSeleccionada="setPersona"></app-busqueda-personas>
            </v-col>
          </v-row>

          <v-row v-if="selectedPersona">
            <v-col>
              <span>Cliente que realiza el Reclamo</span>
            </v-col>
          </v-row>

          <v-row align="center" v-if="selectedPersona">
            <v-col cols="4">
              <v-text-field
                v-model="selectedPersona.cui"
                label="CUI(L/T) "
                key="cuil"
                :disabled="true"></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="selectedPersona.nombreCompleto"
                label="Nombre"
                :disabled="true"></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-btn color="warning" small text @click="limpiar"
                >Cancelar</v-btn
              >
            </v-col>
          </v-row>

          <span v-if="selectedPersona">
            <v-row>
              <v-col cols="3">
                <v-autocomplete
                  v-model="model.empresaId"
                  :items="empresas"
                  autocomplete="disabled"
                  item-text="nombre"
                  item-value="id"
                  label="Empresa"
                  placeholder="Seleccione una"
                  :menu-props="{ minWidth: '400' }"></v-autocomplete>
              </v-col>
              <v-col cols="3">
                <v-autocomplete
                  v-model="model.canalReclamoId"
                  :items="canalesReclamo"
                  autocomplete="disabled"
                  item-text="descripcion"
                  item-value="id"
                  label="Canal"
                  placeholder="Seleccione una"
                  :menu-props="{ minWidth: '400' }"></v-autocomplete>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3">
                <v-text-field
                  v-model="model.email"
                  type="mail"
                  label="Email"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="model.numeroCelular"
                  label="Numero de Celular">
                  <template
                    v-slot:append
                    v-if="!telefonoValidado && !validando">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" @click="validarTelefono"
                          >help_outline</v-icon
                        >
                      </template>
                      <span
                        >Ingresar los 10 números del teléfono (sin el 15 ni el
                        '0' delante del código de área) y presione para
                        validar</span
                      >
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="1">
                <v-icon v-if="telefonoValidado" color="green"
                  >check_circle_outline</v-icon
                >
                <v-icon v-else-if="validando" color="grey">update</v-icon>
              </v-col>
            </v-row>

            <v-row v-if="model.motivoReclamoId === 205" dense>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="model.fechaDevolucion"
                  label="Fecha Devolución"
                  type="date"
                  prepend-icon="event"></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="model.fechaDebito"
                  label="Fecha Débito"
                  type="date"
                  prepend-icon="event"></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="model.importeDevolucion"
                  label="Importe Devolución"
                  :disabled="false"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="model.nroCredito"
                  label="Número de Crédito"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-autocomplete
                  v-model="model.motivoReclamoId"
                  :items="motivosReclamo"
                  autocomplete="disabled"
                  item-text="descripcion"
                  item-value="id"
                  label="Motivo del Reclamo"
                  placeholder="Seleccione una"
                  :menu-props="{ minWidth: '400' }"></v-autocomplete>
              </v-col>
            </v-row>

            <v-row v-if="model.motivoReclamoId === 205">
              <v-col>
                <v-autocomplete
                  v-model="model.motivoReintegroId"
                  :items="motivosReintegro"
                  autocomplete="disabled"
                  item-text="descripcion"
                  item-value="id"
                  label="Motivo del Reintegro"
                  placeholder="Seleccione una"
                  :menu-props="{ minWidth: '400' }"></v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="model.comentarios"
                  class="mx-2"
                  label="Comentarios Adicionales"
                  prepend-icon="comment"
                  clearable
                  auto-grow></v-textarea>
              </v-col>
            </v-row>
          </span>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="blue darken-1" text @click.stop="hide(false)"
          >Cerrar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click.stop="altaReclamo"
          >Confirmar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
//import Vue from 'vue'
import { http } from "@/axios";
//import { addDays, format } from 'date-fns'
//import {Decimal} from 'decimal.js';

import {
  //mapState,
  mapGetters,
  mapMutations,
  //mapActions
} from "vuex";

export default {
  data: () => ({
    saving: false,
    validando: false,
    selectedPersona: null,
    model: {
      empresaId: 0,
      canalReclamoId: 0,
      comentarios: "",
      motivoReclamoId: 0,
      email: "",
      numeroCelular: 0,
      importeDevolucion: 0,
      fechaDevolucion: null,
      fechaDebito: null,
      nroCredito: 0,
      motivoReintegroId: 0,
    },
    numeroReclamo: 0,
    empresas: [],
    canalesReclamo: [],
    motivosReclamo: [],
    reclamos: [],
    origenId: 1,
    accionActualId: 1,
    telefonoValidado: false,
    totalItems: 0,
  }),
  props: {
    modo: { type: String },
  },
  created() {
    this.loadEmpresas();
    this.loadCanalesReclamo();
    this.loadMotivosReclamo();
    this.loadMotivosReintegro();
  },
  computed: {
    ...mapGetters(["getActionFromLink", "user"]),
    listCreditosActivos: function () {
      if (!this.listDeudas || this.listDeudas.length == 0) return [];
      let lista = this.listDeudas.filter(
        (i) => i.tipo == "Credito" || i.tipo == "Acuerdo",
      );

      return lista;
    },
  },
  watch: {
    seAsociaACredito: function () {
      this.listCargosAAplicar = [];
      this.importeCargoAAgregar = 0;
    },
  },
  methods: {
    ...mapMutations([
      "setActiveTask",
      "setActiveSubTask",
      "hideActiveTask",
      "hideActiveSubTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    hide(cerrarRelacionados) {
      //esto lo hago para que no se buguee cuando lo abro como subtask o task
      if (this.isSubTask) this.hideActiveSubTask();
      else this.hideActiveTask(cerrarRelacionados);
    },
    limpiar: function () {
      this.selectedPersona = null;
      this.creditoSeleccionadoId = null;
      this.creditoSeleccionadoNumero = 0;
      this.cuotaSeleccionada = null;
      this.listCargosAAplicar = [];
    },
    async setPersona(persona) {
      this.selectedPersona = persona;
      this.model.personaId = persona.personaId;
      await this.loadReclamosPorUsuario();
      if (this.totalItems != 0)
        this.alertError(
          "La Persona " +
            this.selectedPersona.nombreCompleto +
            " ya tiene un reclamo cargado con estado Abierto, por favor verifique",
        );
    },
    async altaReclamo() {
      if (!this.validarAlta()) return;

      var params = {};
      params.origenId = this.origenId;
      params.personaId = this.model.personaId;
      params.empresaId = this.model.empresaId;
      params.canalReclamoId = this.model.canalReclamoId;
      params.motivoReclamoId = this.model.motivoReclamoId;
      params.accionActualId = this.accionActualId;
      params.email = this.model.email;
      params.comentarios = this.model.comentarios;
      params.numeroCelular = this.model.numeroCelular;
      params.importeDevolucion = this.model.importeDevolucion;
      params.fechaDevolucion = this.model.fechaDevolucion;
      params.motivoReintegroId = this.model.motivoReintegroId;
      params.nroCredito = this.model.nroCredito;
      params.fechaDebito = this.model.fechaDebito;

      try {
        this.saving = true;
        var result = await http.post(
          "reclamos/altareclamo",
          JSON.stringify({ reclamo: params }),
        );
        this.alertSuccess(
          "Se ha generado el Alta del Reclamo " + result.entity.numero,
        );
        this.limpiar();
        this.hide(true);
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.saving = false;
    },
    async loadReclamosPorUsuario() {
      this.loading = true;
      try {
        var result = await http.get(
          "reclamos/list/porusuario?usuarioId=" + this.model.personaId,
        );

        this.reclamos = result.list;
        this.totalItems = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    validarAlta() {
      if (!this.model.personaId) {
        this.alertWarning("Debe elegir una persona.");
        return false;
      }
      if (!this.model.empresaId) {
        this.alertWarning("Debe elegir una Empresa para el Reclamo.");
        return false;
      }
      if (!this.model.canalReclamoId) {
        this.alertWarning("Debe elegir un Canal de Reclamo.");
        return false;
      }

      if (this.model.motivoReclamoId === 205 && !this.model.fechaDevolucion) {
        this.alertWarning("Debe cargar una fecha de Devolución válida.");
        return false;
      }

      if (this.model.motivoReclamoId === 205 && !this.model.fechaDebito) {
        this.alertWarning("Debe cargar una fecha de Débito} válida.");
        return false;
      }

      // if(!this.model.email)
      // {
      //     this.alertWarning('Debe ingresar un Mail para el Reclamo.');
      //     return false;
      // }

      if (!this.model.numeroCelular || !this.telefonoValidado) {
        this.alertWarning(
          "Debe ingresar un Numero de Celular y Validarlo para proceder con el Reclamo.",
        );
        return false;
      }

      if (!this.model.motivoReclamoId) {
        this.alertWarning("Debe ingresar un Motivo de Reclamo.");
        return false;
      }

      if (!this.model.comentarios) {
        this.alertWarning("Debe agregar un Comentario al Reclamo.");
        return false;
      }

      return true;
    },
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get(
          "empresas/list/porusuario?usuarioId=" + this.user.id,
        );

        this.empresas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCanalesReclamo() {
      this.loading = true;
      try {
        var result = await http.get("reclamos/list/tipocanalesreclamo");

        this.canalesReclamo = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadMotivosReclamo() {
      this.loading = true;
      try {
        var result = await http.get("reclamos/list/tipomotivosreclamo");

        this.motivosReclamo = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadMotivosReintegro() {
      this.loading = true;
      try {
        var result = await http.get("reclamos/list/tipomotivosreintegro");

        this.motivosReintegro = result.list;

        // this.motivosReintegro.unshift({ id: 0, descripcion: "(Cualquiera)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async validarTelefono() {
      if (!this.model.numeroCelular) {
        this.alertWarning("Debe ingresar el número de teléfono a validar.");
        return;
      }

      this.validando = true;
      try {
        var result = await http.get(
          "BusinessCore/validartelefonobasegeografica" +
            "?telefono=" +
            this.model.numeroCelular,
        );

        if (!result.esValido) {
          this.alertWarning(result.motivoNoValida);
          this.validando = false;
          return;
        }

        if (result.esFijo) {
          this.alertWarning(
            "Se ingresó un número que no corresponde a Celular. Por favor, verifique.",
          );
          this.validando = false;
          return;
        }

        this.telefonoValidado = result.esValido;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.validando = false;
    },
  },
};
</script>
